export const ReturnSVG = (props) => (
  <svg height={30} viewBox="0 0 34 30" width={34} {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(1 1)">
      <g stroke="#010202" strokeWidth={1.4}>
        <path d="m31.904 9.97h-31.904" strokeLinecap="round" />
        <path d="m31.904 9.97-7.5140407-9.97h-16.88552056l-7.50443874 9.97v17.946h31.904z" />
      </g>
      <g stroke="#1d1d1b">
        <path d="m26.183066 18.831191h-19.74156" strokeWidth={1.4} />
        <path
          d="m8.79931182 16.212959-3.07795077 2.6181252 3.07795077 2.6170583"
          strokeWidth={1.1}
        />
      </g>
    </g>
  </svg>
);
